import { AbstractControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { INewsletter, INewsletterUserInfo } from '../../../_interfaces/newsletter.interface';
import { SdSocialMediaComponent } from '../social-media/social-media.component';
import { SdNewsletterComponent } from '../newsletter/newsletter.component';
import { SdBannerComponent } from '../../medias/banner/banner.component';
import { IIconLink } from '../../../_interfaces/icon-link.interface';
import { IMedia } from '../../../_interfaces/media.interface';
import { BrandsEnum } from '../../../_enums/brands.enum';

@Component({
  selector: 'sd-newsletter-social',
  templateUrl: './newsletter-social.component.html',
  standalone: true,
  imports: [
    SdBannerComponent,
    SdNewsletterComponent,
    SdSocialMediaComponent
  ]
})
export class SdNewsletterSocialComponent implements OnInit {
  showNewsletter = true;

  @Input()
  newsletter: INewsletter;

  @Input()
  socialLinks: IIconLink[];

  @Input()
  media: IMedia;

  @Input()
  formSuccess: boolean;

  @Input()
  isIntrusive = false;

  @Input()
  isRow = true;

  @Input()
  useDQEValidation = false;

  @Input()
  formInputValidation: {
    isValid: boolean;
    errors: ValidationErrors;
  };

  @Input()
  formNewsletter: UntypedFormGroup;

  @Input()
  suggestions = [];

  @Input()
  brand: BrandsEnum;

  @Output()
  inputNewsletterValue = new EventEmitter<INewsletterUserInfo>();

  @Output()
  validateEmailInput = new EventEmitter<AbstractControl>();

  @Output()
  inputChanged = new EventEmitter<AbstractControl>();

  onSubmitNewsletter(value: INewsletterUserInfo) {
    this.inputNewsletterValue.emit(value);
  }

  ngOnInit() {
    this.showNewsletter = this.newsletter
      ? Object.keys(this.newsletter).length > 0
      : false;
  }

  ValidateFormInput(input: AbstractControl) {
    this.validateEmailInput.emit(input);
  }

  onInputChanged(value: AbstractControl) {
    this.inputChanged.emit(value);
  }
}
